import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../utils/api';

export default function UserManage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editModal, setEditModal] = useState(null);

  const loadUsers = useCallback(async () => {
    setLoading(true);
    try { const data = await api.getUsers(); setUsers(data.users); }
    catch (err) { console.error(err); }
    setLoading(false);
  }, []);

  useEffect(() => { loadUsers(); }, [loadUsers]);

  const handleSave = async () => {
    const d = editModal;
    if (!d.username || !d.name || (!d.user_id && !d.password)) {
      alert('Fill all required fields.'); return;
    }
    try {
      if (d._isNew) {
        await api.createUser({ username: d.username, name: d.name, password: d.password, role: d.role, cbsbrcd: d.cbsbrcd, email: d.email, phone: d.phone });
      } else {
        await api.updateUser(d.user_id, { name: d.name, password: d.password || undefined, role: d.role, cbsbrcd: d.cbsbrcd, email: d.email, phone: d.phone });
      }
      setEditModal(null);
      loadUsers();
    } catch (err) { alert(err.message); }
  };

  const handleDelete = async (u) => {
    if (!window.confirm(`Delete user ${u.username}?`)) return;
    try { await api.deleteUser(u.user_id); loadUsers(); }
    catch (err) { alert(err.message); }
  };

  const handleAutoCreate = async () => {
    try {
      const result = await api.autoCreateUsers();
      if (result.created > 0) {
        alert(`✓ Created ${result.created} account(s): ${result.branches.join(', ')}`);
        loadUsers();
      } else {
        alert('All branches already have manager accounts.');
      }
    } catch (err) { alert(err.message); }
  };

  if (loading) return <div className="wrap"><div className="loading">Loading...</div></div>;

  const roleBadge = (role) => {
    const map = { admin: { label: 'ADMIN', cls: 'role-admin' }, 'manager-ho': { label: 'HO MANAGER', cls: 'role-ho' }, manager: { label: 'MANAGER', cls: 'role-mgr' } };
    const m = map[role] || map.manager;
    return <span className={`role-badge ${m.cls}`}>{m.label}</span>;
  };

  return (
    <div className="wrap">
      <div className="page-header">
        <h2>👤 User Management</h2>
        <div className="btn-group">
          <button className="btn btn-a btn-sm" onClick={handleAutoCreate}>⚡ Auto-create from Data</button>
          <button className="btn btn-p btn-sm" onClick={() => setEditModal({ _isNew: true, role: 'manager', cbsbrcd: '' })}>+ Add User</button>
        </div>
      </div>

      <div className="tbl-wrap">
        <table>
          <thead><tr><th>Username</th><th>Name</th><th>Role</th><th>Branch</th><th>Godowns</th><th>Actions</th></tr></thead>
          <tbody>
            {users.map(u => (
              <tr key={u.user_id}>
                <td className="mono fw-600">{u.username}</td>
                <td>{u.name}</td>
                <td>{roleBadge(u.role)}</td>
                <td><strong>{u.cbsbrcd || 'ALL'}</strong></td>
                <td>{u.godown_count || 0}</td>
                <td>
                  <div className="btn-group-sm">
                    <button className="btn btn-o btn-sm" onClick={() => setEditModal({ ...u })}>Edit</button>
                    {u.role !== 'admin' && <button className="btn btn-d btn-sm" onClick={() => handleDelete(u)}>Del</button>}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Edit/Add modal */}
      {editModal && (
        <div className="overlay" onClick={e => e.target.className === 'overlay' && setEditModal(null)}>
          <div className="modal" style={{ maxWidth: 420 }}>
            <h3>{editModal._isNew ? '➕ Add User' : '✏️ Edit User'}</h3>
            <div className="field"><label>Username *</label>
              <input value={editModal.username || ''} onChange={e => setEditModal(p => ({ ...p, username: e.target.value }))} disabled={!editModal._isNew} /></div>
            <div className="field"><label>Name *</label>
              <input value={editModal.name || ''} onChange={e => setEditModal(p => ({ ...p, name: e.target.value }))} /></div>
            <div className="field"><label>{editModal._isNew ? 'Password *' : 'New Password (blank = keep current)'}</label>
              <input type="password" value={editModal.password || ''} onChange={e => setEditModal(p => ({ ...p, password: e.target.value }))} /></div>
            <div className="field"><label>Role</label>
              <select value={editModal.role || 'manager'} onChange={e => setEditModal(p => ({ ...p, role: e.target.value }))}>
                <option value="manager">Branch Manager</option>
                <option value="manager-ho">Manager-HO (View All)</option>
                <option value="admin">Admin</option>
              </select></div>
            {editModal.role === 'manager' && (
              <div className="field"><label>CBS Branch Code *</label>
                <input value={editModal.cbsbrcd || ''} onChange={e => setEditModal(p => ({ ...p, cbsbrcd: e.target.value.toUpperCase() }))} placeholder="e.g. PTC" /></div>
            )}
            <div className="field"><label>Email</label>
              <input type="email" value={editModal.email || ''} onChange={e => setEditModal(p => ({ ...p, email: e.target.value }))} /></div>
            <div className="field"><label>Phone</label>
              <input value={editModal.phone || ''} onChange={e => setEditModal(p => ({ ...p, phone: e.target.value }))} /></div>
            <div className="modal-act">
              <button className="btn btn-o" onClick={() => setEditModal(null)}>Cancel</button>
              <button className="btn btn-p" onClick={handleSave}>{editModal._isNew ? 'Create' : 'Update'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
